import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autocomplete"
export default class extends Controller {

  static targets = ["input", "results"]

  connect() {
    this.resultsTarget.innerHTML = "";
  }

  async search(event) {
    const query = this.inputTarget.value;
    // query = this.inputTarget.value.trim().toLowerCase();
    if(query.length < 1) {
      this.resultsTarget.innerHTML = "";
      return
    }

    // const regions = [
    //   { id: "1", region: "Cambridge" },
    //   { id: "2", region: "Kitchener/Waterloo" },
    //   { id: "3", region: "Guelph" },
    //   { id: "4", region: "Port Credit" }
    // ]

    // const filteredRegions = regions.filter(region => 
    //   region.region.toLowerCase().includes(query)
    // )

    const response = await fetch("/regions.json?query=${query}");
    const regions = await response.json();

    this.resultsTarget.innerHTML = "";

    regions.forEach(region => {
      const item = document.createElement("li");
      item.textContent = region.region;
      item.classList.add("list-group-item");
      item.addEventListener("click", () => {
        this.inputTarget.value = region.region;
        this.resultsTarget.innerHTML = "";
      })
      this.resultsTarget.appendChild(item);
    })

  }
}
